export const roleObj = {
  banned: 'banned',
  demo: 'demo',
  winners: 'winners',
  rating: 'rating',
  calcAndRaiting: 'calcAndRaiting',
  ratingWinners: 'ratingWinners',
  calcRatingWinners: 'calcRatingWinners',
  adminChelkunov: 'adminChelkunov',
  users: 'users',
  manager: 'manager',
  admin: 'admin',
  bankir: 'bankir',
  adminService: 'adminService',
  usersService: 'usersService',
  mangersService: 'managersService',
  finexpertUsers: 'usersFinexpert',
  finexpertManager: 'managerFinexpert',
  finexpertAdmin: 'adminFinexpert',
}

export default [
    {name: "Заблокирован", role: roleObj.banned, id: 0},
    {name: "Демо", role: roleObj.demo, id: 1},
    {name: "Победители", role: roleObj.winners, id: 2},
    {name: "Рейтинги", role: roleObj.rating, id: 3},
    {name: "Калькулятор+Рейтинги", role: roleObj.calcAndRaiting, id: 4},
    {name: "Рейтинги+Победители", role: roleObj.ratingWinners, id: 5},
    {name: "Калькулятор+Рейтинги+Победители", role: roleObj.calcRatingWinners, id: 6},
    {name: "Сотрудник", role: roleObj.users, id: 7},
    {name: "Менеджер", role: roleObj.manager, id: 8},
    {name: "Администратор", role: roleObj.admin, id: 9},
    {name: "Администратор Щелкунов", role: roleObj.adminChelkunov, id: 10},
    {name: "Банкир", role: roleObj.bankir, id: 11},
    {name: "Админ сервиса", role: roleObj.adminService, id: 14},
    {name: "Сотрудник сервиса", role: roleObj.usersService, id: 12},
    {name: "Манеджер сервиса", role: roleObj.mangersService, id: 13},
    {name: "Сотрудник", role: roleObj.finexpertUsers, id: 14},
    {name: "Менеджер", role: roleObj.finexpertManager, id: 15},
    {name: "Администратор", role: roleObj.finexpertAdmin, id: 17},
  ]

// //Как меняются старые роли
// 'Заблокирован' = 'banned'
// 'Сотрудник' = 'users'
// 'Менеджер' = 'manager'
// 'Банкир' = 'bankir'
// 'Администратор' = 'admin'
// 'Админ сервиса' = 'adminService'
// 'Демо пользователь' = 'demo' на "Демо"
// 'Рейтинги и уведомления (участник чата)' = 'ratingWinners' на "Рейтинги+Победители"
// 'Рейтинги (участник чата)' = 'rating' на "Рейтинги"
// 'Пользователь чата' = 'winners' на "Победители"

// //отсутсвующие ранее роли
// 'Калькулятор+Рейтинги+Победители'
// "Калькулятор+Рейтинги"


// Заблокирован                        banned
// Демо                                demo
// Победители                          winners
// Рейтинги                            rating
// Калькулятор+Рейтинги                calcAndRaiting
// Рейтинги+Победители                 ratingWinners
// Калькулятор+Рейтинги+Победители     calcRatingWinners
// Сотрудник                           users
// Менеджер                            manager
// Администратор                       admin
// Администратор Щелкунов              adminChelkunov
// Банкир                              bankir
// Админ сервиса                       adminService
